const validate = (values) => {
  const errors = {};

  // console.log('values.ServiceCode...',values.serviceCode,values.isBillable)

  if (!values.serviceCode) {
    if (!Number.isInteger(values.serviceCode)) {
      errors.serviceCode = 'Please select service code.';
    }
  }

  if (!values.quantity) {
    errors.quantity = 'Please enter unit.';
  }

  if (!values.rate) {
    errors.rate = 'Please enter rate per unit.';
  }

  if (!values.clinicianId || !Number.isInteger(values.clinicianId)) {
    errors.clinicianId = 'Please select clinician';
  }
  if (!values.renderingProviderId || !Number.isInteger(values.renderingProviderId)) {
    errors.renderingProviderId = 'Please select rendering provider';
  }
  if (!values.serviceLocationID || !Number.isInteger(values.serviceLocationID)) {
    errors.serviceLocationID = 'Please select service location';
  }
  if (!values.customAddressID || !Number.isInteger(values.customAddressID)) {
    errors.customAddressID = 'Please select address type';
  }
  if (!values.customAddress) {
    errors.customAddress = 'Please enter other address';
  }

  if (!values.icdCode || !Number.isInteger(values.icdCode)) {
    errors.icdCode = 'Please select primary diagnosis';
  }

  return errors;
};


export default validate;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ValidateServiceCode.js